import { render, staticRenderFns } from "./GridBuyBoxFilter.vue?vue&type=template&id=fa48d5ca&scoped=true"
import script from "./GridBuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridBuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridBuyBoxFilter.vue?vue&type=style&index=0&id=fa48d5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa48d5ca",
  null
  
)

export default component.exports